import { useCallback } from 'react'
import { runSendMessage } from './runSendMessage'

/** @param {object} m */
export function useSendMessageAction(m, onChatEvent) {
  const handleSendMessage = useCallback(
    (payload) => runSendMessage({ ...m, onChatEvent }, payload),
    [m, onChatEvent],
  )
  return { handleSendMessage }
}
